import { Icon } from 'lucide-react'

import { type CustomLucideIconProps } from './props'

export function SolidCircleXIcon ({
  color = 'currentColor',
  ...props
}: CustomLucideIconProps) {
  return (
    <Icon {...props} fill={color} stroke='none' iconNode={[]}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z'
      />
      <path d='M15 9L9 15' stroke='white' strokeWidth='2' />
      <path d='M9 9L15 15' stroke='white' strokeWidth='2' />
    </Icon>
  )
}
